module.exports = __webpack_public_path__ + "static/media/HeadBg.1ce0fc5f.jpg";